module.exports = __webpack_public_path__ + "images/sprites/ui/cv_btn_wide_bold_c3d4cc3afedd50619d0c04fa58bbb337.png";